import React from 'react';

import estatuto from '../../files/estatuto.pdf';
import proposta from '../../files/proposta.pdf';
import pdfIcon from '../../assets/icon_pdf.png';

function Condicoes() {
  return (
    <>
      <h1>Quem pode ser?</h1>
      <p className="institucionalText">Para associar na Cooperativa, o candidato, obrigatoriamente, terá que ser colaborador
        do Grupo Gerdau Aços Finos Piratini em Charqueadas- RS, e Siderúrgica Rio Grandense
        em Sapucaia do Sul e o fara mediante o preenchimento de uma proposta de sócio e da
        autorização para desconto em folha de pagamento das mensalidades.
      </p>
      <p className="institucionalText">Os dados cadastrais serão lançados no sistema da Cooperativa e o desconto das
        mensalidades lançados no sistema do RH da Gerdau Aços Finos Piratini.
      </p>
      <p className="institucionalText">
        A solicitação de desligamento do quadro social se dará mediante pedido por escrito do
        associado, neste caso o associado terá que fazer uma carta solicitando seu
        desligamento do quadro social entre o mês de janeiro até o mês de dezembro do ano
        vigente, sendo que a devolução do capital se dará no mês de abril após Assembleia
        Geral ordinária ou pelo seu desligamento da Gerdau Aços Finos Piratini ou por decisão
        do Conselho de Administração baseado em conduta desabonadora. O associado
        aposentado não se enquadra nesta regra ele poderá a qualquer momento, solicitar seu
        desligamento, e o capital será devolvido conforme decisão do Conselho de
        Administração.
      </p>
      <a href={proposta} target="_blank" rel="noreferrer" className="pdf-button">
        Veja a proposta de sócio
        <img alt="Icone pdf" src={pdfIcon} height="40px" />
      </a>
      <a href={estatuto} target="_blank" rel="noreferrer" className="pdf-button">
        Faça download do estatuto completo
        <img alt="Icone pdf" src={pdfIcon} height="40px" />
      </a>
    </>
  )
}

export default Condicoes;